






















import Vue from 'vue';

export default Vue.extend({
  name: 'GeneralDialog',
  props: ['message', 'dialog', 'emit'],
  methods: {
    closeDialog() {
      this.$emit(this.emit);
    },
  },
});
